import React, { useContext, useEffect, useReducer } from 'react';
import api, { ADMIN_URL, API_BASE_URL } from '../api';
import { Link, useNavigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { Helmet } from 'react-helmet-async';
import { Store } from '../Store';
import CardHeader from '../components/CardHeadder';
import LoadingBox from '../components/LoadingBox';
import MessageBox from '../components/MeaasgeBox';
import Swal from 'sweetalert2';
import { Container, NavDropdown } from 'react-bootstrap';
import { getError } from '../Util';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, fabrics: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    case 'CREATE_REQUEST':
      return { ...state, loadingCreate: true };
    case 'CREATE_SUCCESS':
      return { ...state, loadingCreate: false };
    case 'CREATE_FAIL':
      return { ...state, loadingCreate: false };
    case 'DELETE_REQUEST':
      return { ...state, loadingDelete: true };
    case 'DELETE_SUCCESS':
      return { ...state, loadingDelete: false, successDelete: true };
    case 'DELETE_FAIL':
      return { ...state, loadingDelete: false };
    case 'DELETE_RESET':
      return { ...state, successDelete: false };
    default:
      return state;
  }
};

export default function FabricListScreen() {
  const [
    { loading, error, fabrics, loadingDelete, successDelete, loadingCreate },
    dispatch,
  ] = useReducer(reducer, {
    loading: true,
    error: '',
  });

  const navigate = useNavigate();
  const { state } = useContext(Store);
  const { userInfo } = state;

  useEffect(() => {
    const fetchFabrics = async () => {
      try {
        dispatch({ type: 'FETCH_REQUEST' });
        const { data } = await api.get('/api/fabrics', {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({ type: 'FETCH_SUCCESS', payload: data });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
      }
    };
    if (successDelete) {
      dispatch({ type: 'DELETE_RESET' });
    }
    fetchFabrics();
  }, [userInfo, successDelete]);

  const createHandler = async () => {
    const result = await Swal.fire({
      title: 'Create Fabric?',
      text: 'A sample fabric will be created.',
      icon: 'question',
      showCancelButton: true,
    });

    if (result.isConfirmed) {
      try {
        dispatch({ type: 'CREATE_REQUEST' });
        const { data } = await api.post(
          '/api/fabrics',
          {},
          { headers: { Authorization: `Bearer ${userInfo.token}` } }
        );
        dispatch({ type: 'CREATE_SUCCESS' });
        Swal.fire('Created!', '', 'success');
        navigate(`/admin/fabric/${data.fabric._id}`);
      } catch (err) {
        dispatch({ type: 'CREATE_FAIL' });
        Swal.fire('Error!', getError(err), 'error');
      }
    }
  };

  const deleteHandler = async (fabricId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'This fabric will be permanently deleted!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        dispatch({ type: 'DELETE_REQUEST' });
        await api.delete(`/api/fabrics/${fabricId}`, {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({ type: 'DELETE_SUCCESS' });
        // Refresh the list after deletion
        const { data } = await api.get('/api/fabrics', {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({ type: 'FETCH_SUCCESS', payload: data });
        Swal.fire('Deleted!', 'The fabric has been deleted.', 'success');
      } catch (err) {
        dispatch({ type: 'DELETE_FAIL' });
        Swal.fire({
          icon: 'error',
          title: 'Delete Failed',
          text: getError(err),
          showConfirmButton: true,
        });
      }
    }
  };

  const { dispatch: ctxDispatch } = useContext(Store);

  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    localStorage.removeItem('userInfo');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('paymentMethod');
    window.location.href = '/signin';
  };

  return (
    <div>
      <CardHeader />
      <Container fluid="md" className="mt-5 py-5">
        <Helmet>
          <title>Fabric Management</title>
        </Helmet>
        <Col>
          <h1 className="fs-2 mb-4">Fabric Management</h1>
        </Col>
        <Row className="align-items-center mb-4 d-flex justify-content-between flex-wrap">
          <Col xs="auto" className="text-start">
            <Button onClick={createHandler} disabled={loadingCreate}>
              {loadingCreate ? 'Creating...' : 'Create Fabric'}
            </Button>
          </Col>

          <Col
            xs="auto"
            className="d-flex justify-content-end align-items-center"
          >
            {userInfo ? (
              <NavDropdown
                title={<span className="text-black">{userInfo.name}</span>}
                id="collasible-nav-dropdown"
              >
                <NavDropdown.Item as={Link} to="/profile">
                  <span className="text-gray">User Profile</span>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <Link
                  className="dropdown-item"
                  to="#signout"
                  onClick={signoutHandler}
                >
                  <span className="text-gray">Signout</span>
                </Link>
              </NavDropdown>
            ) : (
              <a className="nav-link text-black" href={ADMIN_URL}>
                <span className="text-black">Signin</span>
              </a>
            )}

            {userInfo && userInfo.isAdmin && (
              <NavDropdown
                title={<span className="text-black">Admin</span>}
                id="admin-nav-dropdown"
                className="ms-3"
              >
                <NavDropdown.Item as={Link} to="/admin/products">
                  <span className="text-gray">Products</span>
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/admin/orders">
                  <span className="text-gray">Orders</span>
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/admin/fabrics">
                  <span className="text-gray">Fabrics</span>
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Col>
        </Row>

        {loadingDelete && <LoadingBox />}
        {loading ? (
          <LoadingBox />
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <div className="table-responsive overflow-auto">
            <Table striped bordered hover className="align-middle shadow-sm">
              <thead className="table-dark">
                <tr>
                  <th className="px-3">Image</th>
                  <th className="px-3">Fabric Name</th>
                  <th className="px-3">Fabric Code</th> {/* Added */}
                  <th className="px-3">Descriptions</th>
                  <th className="px-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                {fabrics.map((fabric) => (
                  <tr key={fabric._id}>
                    <td>
                      <img
                        src={fabric.image ? (fabric.image.startsWith('http') ? fabric.image : `${API_BASE_URL}/storage/${fabric.image}`) : ''}
                        alt={fabric.name}
                        style={{ width: '80px', height: 'auto' }}
                      />
                    </td>
                    <td className="fw-semibold">{fabric.name}</td>
                    <td>{fabric.fabricCode}</td> {/* Added */}
                    <td>
                      <ul className="mb-0 ps-3">
                        {(Array.isArray(fabric.description) ? fabric.description : (typeof fabric.description === 'string' ? [fabric.description] : [])).map((desc, idx) => (
                          <li key={idx}>{desc}</li>
                        ))}
                      </ul>
                    </td>
                    <td className="text-nowrap">
                      <div className="d-flex gap-2">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="rounded-pill px-3"
                          onClick={() =>
                            navigate(`/admin/fabric/${fabric._id}`)
                          }
                        >
                          <i className="bi bi-pencil-square me-1"></i>Edit
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="rounded-pill px-3"
                          onClick={() => deleteHandler(fabric._id)}
                        >
                          <i className="bi bi-trash me-1"></i>Delete
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Container>
    </div>
  );
}
